import { dateFormat } from "../../const/date";
import sanitizeHtml from "sanitize-html";

type BlogData = {
  data: {
    category: Array<string>;
    title: Array<string>;
    link: Array<string>;
    description: Array<string>;
    pubDate: Array<string>;
  }[];
};

/** 하수코 솔루션 네이버 블로그 */
const NAVER_BLOG_URL = "https://blog.naver.com/pkpk1440";

/**
 * 데스크톱(6열 그리드)에서 각 카드의 시작 열.
 * 로고 카드(가운데)를 기준으로 위·아래 행이 엇갈리도록 배치한다.
 *   1행:  최신(1) · [로고](3) · 두번째(5)
 *   2행:        세번째(2) · 네번째(4)
 *   3행:  다섯(1) · 여섯(3) · 일곱(5)
 */
const POST_COL_START = [
  "lg:col-start-1",
  "lg:col-start-5",
  "lg:col-start-2",
  "lg:col-start-4",
  "lg:col-start-1",
  "lg:col-start-3",
  "lg:col-start-5",
];

const Blog = ({ data }: { data: BlogData[] | any[] }) => {
  const blog = ParseData({ data });
  const posts = blog.slice(0, 7);

  const getTranslated = (key: string) => {
    const text = key || ""; //data json에서 호출
    const sanitizedText = sanitizeHtml(text, {
      allowedTags: ["br", "em", "span"], //허용할 태그 지정
    });
    return { __html: sanitizedText };
  };

  const renderCard = (v: any, colStart: string, key: string | number) => (
    <div
      data-aos="fade-up"
      key={key}
      onClick={() => window.open(v.link[0])}
      className={`${colStart} cursor-pointer lg:col-span-2`}
    >
      <div className="flex h-full flex-col rounded-lg border border-[#cdd6f5] bg-white p-5 text-left transition-all duration-300 hover:border-primary hover:shadow-md">
        <p className="gbold truncate text-primary md:text-lg">{v.title[0]}</p>
        <small
          className="mt-2 line-clamp-2 break-words text-sm text-lightGray opacity-70"
          dangerouslySetInnerHTML={getTranslated(v.description[0])}
        />
        <div className="mt-auto flex items-end justify-between pt-3">
          <small className="hidden text-xs opacity-40 xl:block">{dateFormat(v.pubDate[0])}</small>
          <small className="text-xs text-primary opacity-80">{v.category[0]}</small>
        </div>
      </div>
    </div>
  );

  return (
    <div id="blog" className="relative w-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-24 xl:py-28">
      <div className="mx-auto max-w-[1200px]">
        {/* 상단 타이틀 */}
        <div className="text-center" data-aos="fade-up">
          <h3 className=" font-medium text-xl md:text-2xl">어떻게 작업이 진행되는지 궁금하신가요?</h3>
          <h2 className="gbold text-primary">하수코 솔루션의 생생한 현장을 확인해보세요</h2>
        </div>

        {/* 카드 그리드 (데스크톱: 6열 엇갈림 배치) */}
        <div className="mt-10 grid grid-cols-2 grid-flow-dense gap-4 text-black lg:grid-cols-6 lg:grid-flow-row lg:gap-5">
          {/* 1행 좌: 가장 최신 글 */}
          {posts[0] && renderCard(posts[0], POST_COL_START[0], "post-0")}

          {/* 1행 중앙: 로고 카드 (고정) */}
          <div
            data-aos="fade-up"
            onClick={() => window.open(NAVER_BLOG_URL)}
            className="col-span-2 flex cursor-pointer items-center justify-center gap-3 rounded-lg border border-[#cdd6f5] bg-white p-5 lg:col-start-3"
          >
            <img src="/images/blogLogo.png" alt="하수코 솔루션" className="h-9 w-auto md:h-12 lg:h-14" />
          </div>

          {/* 나머지 글: 데이터가 자동으로 채워짐 */}
          {posts.slice(1).map((v, i) => renderCard(v, POST_COL_START[i + 1], `post-${i + 1}`))}
        </div>
      </div>
    </div>
  );
};

export default Blog;

const parseString = require("xml2js").parseString;

const ParseData = ({ data }: { data: any[] }) => {
  const dataArr: {
    title: any;
    link: any;
    description: any;
    pubDate: any;
    category: any;
  }[] = [];

  parseString(data, (err: any, result: any) => {
    if (err) {
      console.error("XML 파싱 에러:", err);
      return;
    }

    const items = result?.rss?.channel?.[0]?.item;
    if (Array.isArray(items)) {
      items.slice(0, 9).forEach((v: any) => {
        dataArr.push({
          title: v.title,
          link: v.link,
          description: v.description,
          pubDate: v.pubDate,
          category: v.category,
        });
      });
    } else {
      console.warn("item 배열이 없습니다.");
    }
  });

  return dataArr;
};
